//libs
import { styled } from '@nykaa/ui-components';

export const Heading = styled.h3`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.titleMedium}
  margin: ${({ theme }) => theme.spacing.spacing0};
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
  border-bottom: 1px solid ${({ theme }) => theme.colors.textDecorative};
`;
